"use client";

import { Suspense } from "react";
import { LoginFormCore } from "@/components/auth/loginCore";
import { useRouter, useSearchParams } from "next/navigation";
import { customToast } from "@/components/ui/custom-toast";

function LoginPageInner() {
    const router = useRouter();
    const searchParams = useSearchParams();

    const handleLoginSuccess = () => {
        customToast.success("Welcome back!");
        const redirect = searchParams.get('redirect');
        router.push(redirect && redirect.startsWith('/') ? redirect : '/scorer');
    };

    return (
        <div className="flex min-h-screen items-center justify-center bg-muted/20 p-4">
            <div className="w-full max-w-md bg-background rounded-2xl shadow-sm overflow-hidden border border-border">
                <LoginFormCore
                    onSwitchToSignup={() => {
                        const redirect = searchParams.get('redirect');
                        router.push(redirect ? `/signup?redirect=${encodeURIComponent(redirect)}` : '/signup');
                    }}
                    onLoginSuccess={handleLoginSuccess}
                />
            </div>
        </div>
    );
}

export default function LoginPage() {
    return (
        <Suspense fallback={
            <div className="flex min-h-screen items-center justify-center">
                <div className="w-6 h-6 border-2 border-primary border-t-transparent rounded-full animate-spin" />
            </div>
        }>
            <LoginPageInner />
        </Suspense>
    );
}
